import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/junli/work/fun/hooks/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { usePrevious } from "../../index";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "useprevious"
    }}>{`usePrevious`}</h1>
    <p>{`保存上一次渲染时的状态`}</p>
    <hr />
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const [
  prev: any, // 上一次的值
] = useImage(
  state: any, // 要计算的值
);
`}</code></pre>
    <hr />
    <h2 {...{
      "id": "demo"
    }}>{`DEMO`}</h2>
    <Playground __position={2} __code={'() => {\n  const [count, setCount] = React.useState(0)\n  const preCount = usePrevious(count)\n  return (\n    <div>\n      <div>preCount: {preCount}</div>\n      <div>count: {count}</div>\n      <button onClick={() => setCount(pre => pre + 1)}>+</button>\n    </div>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      usePrevious,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const [count, setCount] = React.useState(0);
        const preCount = usePrevious(count);
        return <div>
        <div>preCount: {preCount}</div>
        <div>count: {count}</div>
        <button onClick={() => setCount(pre => pre + 1)}>+</button>
      </div>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      